import {
    makeStyles,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Typography,
    TableSortLabel,
    Checkbox,
} from "@material-ui/core";
import React from 'react';
import LinhaLotes from './LinhaLotes';
import MensagemListagemVazia from "../../../shared/components/MensagemListagemVazia";
import { LISTAGEM_VAZIA_FILTROS } from "../../../shared/utils/Constantes";
import { CheckCircle, Circle, MinusCircle } from 'react-feather';
import { SECONDARY_COLOR } from "../../../theme";

const ListaLotes = ({
    listaLotes,
    handleOrdenacao,
    ordemDecrescente,
    handleClickBaixarImagemBiopsia,
    handleClickBaixarAssinaturaDigital,
    handleClickGerarReciboRecolhimento,
    handleVisualizarLote,
    lotesSelecionados,
    lotesSelecionaveis,
    handleSelecionar,
    handleSelecionarTodos,
}) => {

    const classes = useStyles();
    
    return (
        <>
            <Table stickyHeader size={"small"} className={classes.root}>
                <TableHead>
                    <TableRow className={classes.header}>
                        <TableCell className={classes.checkBox}>
                            <Checkbox
                                className={classes.checkBox}
                                indeterminate={lotesSelecionados.length > 0 && lotesSelecionados.length < lotesSelecionaveis.length}
                                indeterminateIcon={<MinusCircle size={16} />}
                                checked={lotesSelecionados.length === lotesSelecionaveis.length}
                                icon={<Circle size={16} />}
                                checkedIcon={<CheckCircle color={SECONDARY_COLOR} size={16} />}
                                onChange={handleSelecionarTodos}
                                inputProps={{ 'aria-label': 'selecionar todos os lotes' }}
                            />
                        </TableCell>
                        <TableCell style={{width: "120px"}} size={"small"} align="left">
                            <Typography variant={"body2"}>N° da Etiqueta</Typography>
                        </TableCell>
                        <TableCell size={"small"} align="left">
                            <Typography variant={"body2"}>Tipo</Typography>
                        </TableCell>
                        <TableCell style={{width: "5px"}} padding="none" />
                        <TableCell style={{width: "130px"}} size={"small"} align="left">
                            <Typography variant={"body2"}>Conservação</Typography>
                        </TableCell>
                        <TableCell size={"small"} align="left">
                            <Typography variant={"body2"}>Status</Typography>
                        </TableCell>
                        <TableCell style={{width: "5px"}} padding="none" />
                        <TableCell style={{width: "80px"}} size={"small"} align="left">
                            <Typography variant={"body2"}>Qtd. Amostras</Typography>
                        </TableCell>
                        <TableCell style={{width: "80px"}} size={"small"} align="left">
                            <Typography variant={"body2"}>Temp. Cadastro</Typography>
                        </TableCell>
                        <TableCell style={{width: "150px"}} size={"small"} align="left">
                            <TableSortLabel
                                active={true}
                                direction={ordemDecrescente ? 'desc' : 'asc'}
                                onClick={handleOrdenacao}
                            >
                                <Typography variant={"body2"}>Data Cadastro</Typography>
                            </TableSortLabel>
                        </TableCell>
                        <TableCell style={{width: "150px"}} size={"small"} align="left">
                            <Typography variant={"body2"}>Data Recolhimento</Typography>
                        </TableCell>
                        <TableCell style={{width: "80px"}} size={"small"} align="left">
                            <Typography variant={"body2"}>Temp. Chegada</Typography>
                        </TableCell>
                        <TableCell style={{width: "10px"}} size={"small"} align="left">
                            <Typography variant={"body2"}>Ações</Typography>
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {listaLotes && listaLotes.map((item, index) => (
                        <LinhaLotes
                            key={item.codigo + index.toString()}
                            lote={item}
                            handleClickBaixarAssinaturaDigital={handleClickBaixarAssinaturaDigital}
                            handleClickBaixarImagemBiopsia={handleClickBaixarImagemBiopsia}
                            handleClickGerarReciboRecolhimento={handleClickGerarReciboRecolhimento}
                            index={index}
                            handleVisualizarLote={handleVisualizarLote}
                            selecionado={lotesSelecionados.some(lote => lote.id === item.id)}
                            handleSelecionar={handleSelecionar}
                        />
                    ))}
                </TableBody>
            </Table>
            {
                listaLotes && listaLotes.length === 0 &&
                <MensagemListagemVazia
                    mensagem={LISTAGEM_VAZIA_FILTROS}
                />
            }
        </>
    );
}

const useStyles = makeStyles((theme) => ({
    root: {
        width: "99%",
        "& #form": {
            left: "-52px",
        },
        "& #form > div > div": {
            boxShadow: "none",
            borderStyle: "none",
        },
        "& .MuiBadge-root": {
            width: "5px",
        },
    },
    header: {
        height: "7vh",
    },
    fontRowHeader: {
        fontSize: "16px",
    },
    checkBox: {
      padding: "0px 0px 0px 0px"
    },
}))

export default ListaLotes;